import { NavLink } from "react-router-dom";
import logoWhite from "/Users/michaeltucker/Documents/coding-projects/client/src/assets/img/square-logo-white.png";

const FOOTER_LINKS_LEFT = [
  { key: "pricing", label: "Pricing", landingHref: "#pricing", href: "/pricing" },
  { key: "help", label: "Help Center", landingHref: "#faq", href: "/#faq" },
  { key: "contact", label: "Contact / Support", href: "/contact" },
  { key: "login", label: "Login", href: "/auth/login" },
];

const FOOTER_LINKS_RIGHT = [
  { key: "privacy", label: "Privacy Policy", href: "/privacy" },
  { key: "terms", label: "Terms", href: "/trust" },
  { key: "schools", label: "Schools & Districts", href: "/for-administrators" },
  { key: "ambassadors", label: "Ambassador Program", href: "/ambassadors" },
];

const FooterLink = ({ link, onLandingPage }) => {
  if (onLandingPage && link.landingHref) {
    return (
      <a href={link.landingHref} className="landing-v2-footer__link">
        {link.label}
      </a>
    );
  }

  return (
    <NavLink to={link.href} className="landing-v2-footer__link">
      {link.label}
    </NavLink>
  );
};

const LandingPageFooter = ({ onLandingPage = false }) => (
  <footer className="landing-v2-footer">
    <div className="landing-v2-footer__inner">
      <div className="landing-v2-footer__brand">
        <div className="landing-v2-footer__meta">
          <div>Charlotte, North Carolina</div>
          <div>Lesson Launchpad™ © 2026 - All Rights Reserved</div>
        </div>
        <div className="landing-v2-footer__social">
          <a
            href="https://www.facebook.com/lessonlaunchpad"
            target="_blank"
            rel="noopener noreferrer"
            className="landing-v2-footer__social-link"
            aria-label="Lesson Launchpad on Facebook"
          >
            <i className="fa fa-facebook-square" />
          </a>
          <a
            href="https://www.youtube.com/@LessonLaunchpad"
            target="_blank"
            rel="noopener noreferrer"
            className="landing-v2-footer__social-link"
            aria-label="Lesson Launchpad on YouTube"
          >
            <i className="fa fa-youtube" />
          </a>
        </div>
      </div>

      <nav className="landing-v2-footer__nav" aria-label="Footer">
        <div className="landing-v2-footer__nav-col">
          {FOOTER_LINKS_LEFT.map((link) => (
            <FooterLink key={link.key} link={link} onLandingPage={onLandingPage} />
          ))}
        </div>
        <div className="landing-v2-footer__nav-col">
          {FOOTER_LINKS_RIGHT.map((link) => (
            <FooterLink key={link.key} link={link} onLandingPage={onLandingPage} />
          ))}
        </div>
      </nav>

      <div className="landing-v2-footer__logo-wrap">
        <img
          src={logoWhite}
          alt="Lesson Launchpad"
          className="landing-v2-footer__logo"
        />
      </div>
    </div>
  </footer>
);

export default LandingPageFooter;
